import {RouterConfigInstance} from "./configs/router_config";
import {RouterModulesConfigurations} from "modules/router/RouterModuleConfiguration";


RouterModulesConfigurations
    .createNewModule()
    .config(RouterConfigInstance);